import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BookingSystemAPI } from '../services/BookingSystemAPI';
import './VerifyEmail.css';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
  const [message, setMessage] = useState('Email wird verifiziert...');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('error');
        setMessage('Kein Verifizierungstoken gefunden.');
        return;
      }

      try {
        const api = new BookingSystemAPI();
        const result = await api.verifyEmail(token);

        if (result.success) {
          setStatus('success');
          setMessage(result.message);

          // Redirect to login after 3 seconds
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } else {
          setStatus('error');
          setMessage(result.message);
        }
      } catch (error: any) {
        setStatus('error');
        setMessage(error.message || 'Ein Fehler ist aufgetreten');
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="verify-email-container">
      <div className="verify-email-card">
        <div className={`verify-email-icon ${status}`}>
          {status === 'verifying' && (
            <div className="spinner"></div>
          )}
          {status === 'success' && (
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          )}
          {status === 'error' && (
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          )}
        </div>

        <h1 className="verify-email-title">
          {status === 'verifying' && 'Email-Verifizierung'}
          {status === 'success' && 'Erfolgreich verifiziert!'}
          {status === 'error' && 'Verifizierung fehlgeschlagen'}
        </h1>

        <p className="verify-email-message">{message}</p>

        {status === 'success' && (
          <p className="verify-email-redirect">
            Sie werden in wenigen Sekunden zur Anmeldung weitergeleitet...
          </p>
        )}

        {status === 'error' && (
          <button
            className="verify-email-button"
            onClick={() => navigate('/login')}
          >
            Zur Anmeldung
          </button>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
